import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10bb0f65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highlight-item" }
const _hoisted_2 = { class: "wrapper-img" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "highlight-img",
        src: require('@/assets/itens/' + _ctx.imageFileName),
        alt: _ctx.altText
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
  ]))
}